(function(w, $, _) {
    'use strict';

    const assetId = '~/Parts/Views/Site/SmartSearch.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        // ReSharper disable UndeclaredGlobalVariableUsing
        const $mainPanel = $('#' + ctx.mainPanelId);
        const labels = ctx.labels;
        const settings = ctx.settings;
        const compiledTemplate = _.template(ctx.templateContent);
        const pubSub = w.PubSub;
        // ReSharper restore UndeclaredGlobalVariableUsing
        w.require(['typeahead', 'bloodhound'],
            function () {
                $(function () {
                    let qtyMap = {};
                    
                    const $searchBtn = $mainPanel.find('.smart-search__btn');
                    const $searchInput = $mainPanel.find('.smart-search__input');
                    $searchBtn.on('click',
                        function(e) {
                            e.preventDefault();
                            const term = $.trim($searchInput.val());
                            if (term) {
                                w.location = w.R + settings.searchUrl + encodeURIComponent(term);
                            }
                        });
                    $searchInput.on('keypress',
                        function(e) {
                            if (e.keyCode == 13) {
                                e.preventDefault();
                                $searchBtn.trigger('click');
                            }
                        });

                    function notify(message, type) {
                        const channel = typeof (type) === 'string' && type ? 'notification.' + type : 'notification';
                        w.PubSub.publish(channel, message);
                    }

                    w.PublicEStore.subscribe(w.PublicEStore.channels.callback.shopCart + '.' + w.PublicEStore.actions.addToCart, addToCartHandler);
                    w.PublicEStore.subscribe(w.PublicEStore.channels.callback.shopCart + '.' + w.PublicEStore.actions.removeFromCart, removeFromCartHandler);
                    w.PublicEStore.subscribe(w.PublicEStore.channels.callback.shopCart + '.' + w.PublicEStore.actions.emptyCart, emptyCartHandler);

                    function addToCartHandler(topic, dataContract) {
                        addToCartCallback(dataContract);
                    }

                    function removeFromCartHandler(topic, dataContract) {
                        _.each(dataContract.result.items,
                            function(prod) {
                                if (prod.status.toLowerCase() === 'ok' && typeof (qtyMap[prod.productID]) === 'number') {
                                    qtyMap[prod.productID] = 0;
                                    const $prodCont = $mainPanel.find('[data-prodid="' + prod.productID + '"]');
                                    $prodCont.removeClass('smart-search-suggestion_in-cart');
                                    $prodCont.find('.smart-search-suggestion__fa-shopping-cart').remove();
                                }
                            });
                    }

                    function emptyCartHandler(topic, dataContract) {
                        if (dataContract.status.toLowerCase() === 'ok') {
                            for (let qty in qtyMap) {
                                if (qtyMap.hasOwnProperty(qty)) {
                                    qtyMap[qty] = 0;
                                }
                            }
                            const $prodConts = $mainPanel.find('.smart-search-suggestion_product');
                            $prodConts.removeClass('smart-search-suggestion_in-cart');
                            $prodConts.find('.smart-search-suggestion__fa-shopping-cart').remove();
                        }
                    }

                    function addToCartCallback(dataContract) {
                        _.each(dataContract.result.items,
                            function(prod) {
                                if (prod.status.toLowerCase() === 'ok') {
                                    if (typeof (qtyMap[prod.productID]) === 'number') {
                                        if (qtyMap[prod.productID] === 0) {
                                            const $prodCont = $mainPanel.find('[data-prodid="' + prod.productID + '"]');
                                            $prodCont.addClass('smart-search-suggestion_in-cart');
                                            $prodCont.find('.smart-search-suggestion__image-container')
                                                .append('<i class="smart-search-suggestion__fa-shopping-cart fa fa-shopping-cart" aria-hidden="true"></i>');
                                        }

                                        qtyMap[prod.productID] += prod.quantity;
                                    }
                                } else {
                                    notify(prod.message, 'error');
                                }
                            });
                    }

                    function errorCallback(errorContract) {
                        if (errorContract) {
                            const msg = typeof errorContract === 'string'
                                ? errorContract
                                : errorContract.result && errorContract.result.items[0]
                                ? errorContract.result.items[0].message
                                : errorContract.message;
                            notify(msg, 'error');
                        }
                    };

                    var qtyFocusing = false;

                    function validateQty($cont) {
                        const $qtyTxb = $cont.find('.js-qty-txb');
                        const qtyVal = $qtyTxb.val();

                        if (qtyVal && $.isNumeric(qtyVal)) {
                            const intQty = parseInt(qtyVal);
                            const minQty = $cont.data('qty');

                            if (intQty >= minQty) {
                                $cont.removeClass('has-error');
                                return true;
                            }
                        }

                        $cont.addClass('has-error');
                        return false;
                    }

                    function changeQty($cont, diff) {
                        if (validateQty($cont)) {
                            const $qtyTxb = $cont.find('.js-qty-txb');
                            let intQty = parseInt($qtyTxb.val());

                            if (diff > 0) {
                                intQty += diff;
                            } else {
                                const minQty = $cont.data('qty');

                                if (intQty > minQty) {
                                    intQty += diff;
                                }
                            }

                            $qtyTxb.val(intQty);
                        }
                    }

                    // ReSharper disable UndeclaredGlobalVariableUsing
                    var products = new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: w.R +
                                'handlers/public/ItemSearch.ashx?action=smartsearch' +
                                '&types=' + (settings.types || '20') +
                                (settings.rootPages ? '&rootpages=' + settings.rootPages : '') +
                                (settings.rootFolders ? '&rootfolders=' + settings.rootFolders : '') +
                                (settings.rootCategories ? '&rootcategories=' + settings.rootCategories : '') +
                                (settings.imageWidth ? '&imageWidth=' + settings.imageWidth : '') +
                                (settings.imageMod ? '&imageMod=' + settings.imageMod : '') +
                                '&showPrice=' + settings.showPrice +
                                (settings.showOriginalPrice ? '&showOriginalPrice=' + settings.showOriginalPrice : '') +
                                '&showComparablePrice=' + settings.showComparablePrice +
                                '&count=' + settings.resultsCount +
                                '&term=%QUERY',
                            wildcard: '%QUERY'
                        }
                    });
                    // ReSharper restore UndeclaredGlobalVariableUsing

                    const $ta = $mainPanel.find('.js-typeahead');
                    $ta.typeahead(
                            { highlight: true, hint: false, minLength: settings.minTermLength },
                            {
                                name: 'products',
                                display: 'title',
                                source: products,
                                limit: (settings.resultsCount + 1) * 2, //note: typeahead workaround (rendered counter is incremented before slicing results array)
                                templates: {
                                    empty: [
                                        '<div class="smart-search-empty-message">',
                                        labels.noItemsFound,
                                        '</div>'
                                    ].join('\n'),
                                    suggestion: function(context) {
                                        if (context.type === 'prod') {
                                            if (typeof (qtyMap[context.prodID]) === 'undefined') {
                                                qtyMap[context.prodID] = context.qtyInCart ? context.qtyInCart : 0;
                                            } else {
                                                context.qtyInCart = qtyMap[context.prodID];
                                            }
                                        }

                                        return compiledTemplate({
                                            ctx: context,
                                            searchUrl: w.R + settings.searchUrl,
                                            labels: labels,
                                            settings: settings
                                        });
                                    }
                                }
                            })
                        .bind('typeahead:render',
                            function () {
                                $mainPanel.find('.js-qty-cont')
                                    .each(function(i, cont) {
                                        const $cont = $(cont);
                                        $cont.find('.js-btn-dec')
                                            .click(function() {
                                                changeQty($cont, -1);
                                                return false;
                                            });
                                        $cont.find('.js-btn-inc')
                                            .click(function() {
                                                changeQty($cont, 1);
                                                return false;
                                            });
                                        $cont.find('.js-qty-txb')
                                            .click(function() {
                                                qtyFocusing = true;
                                                const $this = $(this);
                                                $this[0].selectionStart = $this[0].selectionEnd = $this.val().length;
                                                $this.focus();
                                                return false;
                                            })
                                            .blur(function(e) {
                                                if (qtyFocusing) {
                                                    qtyFocusing = false;
                                                } else if (!e.relatedTarget || !$.contains($mainPanel[0], e.relatedTarget)) {
                                                    $ta.typeahead('close');
                                                }
                                            })
                                            .change(function () {
                                                validateQty($cont);
                                            });
                                    });

                                $mainPanel.find('.smart-search-suggestion__buy-btn')
                                    .on('click',
                                        function() {
                                            const $cont = $(this).closest('.smart-search-suggestion_product');
                                            const $qtyCont = $cont.find('.js-qty-cont');
                                            let qty;

                                            if ($qtyCont.length) {
                                                if (!validateQty($qtyCont)) {
                                                    return false;
                                                }

                                                qty = parseInt($cont.find('.js-qty-txb').val());
                                            } else {
                                                qty = $cont.data('qty');
                                            }

                                            const addContract = {
                                                productId: $cont.data('prodid'),
                                                quantity: qty
                                            };
                                            $.when(w.PublicEStore.addToCart([addContract]))
                                                .then(addToCartCallback, errorCallback);
                                            return false;
                                        });
                                
                                reportImpressions($mainPanel);
                            })
                        .bind('typeahead:select',
                            function(e, data) {
                                if (data) {
                                    if (data.type === 'prod' && data.prodUrl) {
                                        w.location = data.prodUrl;
                                    } else if (data.type === 'document' && data.documentUrl) {
                                        w.location = data.documentUrl;
                                    } else if (data.type === 'event' && data.eventUrl) {
                                        w.location = data.eventUrl;
                                    }
                                }
                            });

                    //note: typeahead workaround - result items were closing on setting focus at quantity input
                    var origClose = $ta.data('ttTypeahead').close;
                    $ta.data('ttTypeahead').close = function() {
                        if (!qtyFocusing) {
                            origClose.apply(this, arguments);
                        }
                        qtyFocusing = false;
                    };
                    pubSub.publish("frontend.smartsearch.init", "init");

                    function reportImpressions($searchResults) {
                        try {
                            const listName = $.trim(document.title) + ' > ' + labels.smartSearch;
                            const productImpressions = [];

                            $searchResults.find('[data-prodid]').each(function () {
                                const $prod = $(this);

                                const productId = parseInt($prod.data('prodid'));
                                if (productId > 0) {
                                    productImpressions.push({ productId: productId, $links: $prod.find('.js-product-link') });
                                }
                            });
                            
                            if (productImpressions.length > 0) {
                                w.reportProductListView(w.productListType.searchResults, listName, productImpressions);
                            }
                        } catch (e) {
                            console.error('Failed to report smartsearch\'s products impressions. ' + e);
                        }
                    }
                });
            });
    }
})(window, window.jQuery, _);